import React, {useState} from 'react'
import {Button, Modal} from "antd";
import {deleteProduction} from "../../services/serviceProductionLine";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const ProductionLineDelete = ({production, updater}) => {

    const [deleteModal, setDeleteModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleDeleteClick = (decision) => {
        if (decision){
            enterLoadingState(setLoadings)
            deleteProduction(production.id)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setDeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }else{
            setDeleteModal(!deleteModal)
        }
    }

    return(
        <React.Fragment>
            <Button type={'link'} danger onClick={()=>setDeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                closable={false}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button type={'primary'} danger key={'submitButton'} loading={loadings[0]} onClick={()=> handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>

        </React.Fragment>
    )
}
export default ProductionLineDelete